import React from "react";
import "../../Css/Projects/Projects.css";

const NumberTheory2 = () => {
  return (
    <div className="project">
      <div className="head">Number Theory 2</div>
      <div className="desc">
        It's a npm package that can be used to perform number theory operations like finding GCD, LCM, prime factorization, etc. Its a large package with about 50+ functions from
        different domains of number theory. I try to keep updating it with new functions and features. Any contributions are more than welcome.
      </div>
      <div className="links">
        <a target="_" href="https://www.npmjs.com/package/number-theory-2">
          NPM
        </a>
        <a target="_" href="https://github.com/AayushMainali-Github/number-theory-2">
          Github
        </a>
      </div>
    </div>
  );
};

export default NumberTheory2;
